import {assert} from 'assert-ts';
import type {ValidationResult} from 'schemaDefinition/functions/validators/types';
import type {MetadataValidationResult} from 'schemas/types';
import {getValidationPrPart} from 'schemaDefinition/functions/validators';

type TransformValidationResult = (
  validationResult: ValidationResult | undefined,
) => ValidationResult | undefined;
const transformValidationResults = (
  validation: MetadataValidationResult,
  transform: TransformValidationResult,
): MetadataValidationResult => {
  return {
    ...validation,
    work: transform(validation.work),
    expressions: validation.expressions?.map(expression => ({
      ...expression,
      validation: assert(transform(expression.validation)),
      manifestations: expression.manifestations.map(m => ({
        ...m,
        validation: assert(transform(m.validation)),
      })),
    })),
  };
};

export const getMostSevereMetadataValidationPrPart = (
  validation: MetadataValidationResult,
): MetadataValidationResult => {
  return transformValidationResults(validation, getValidationPrPart);
};
